export class Message {
  timestamp: Date;
  title: string;
  content: string;
  origin: number;
  status: SendingStatus;

  openState = false;

  constructor(json?: any) {
    if (!json)
      return;

    this.timestamp = json.timestamp ? new Date(json.timestamp) : null;
    this.title = null;
    this.content = json.content || '';
    this.origin = json.origin;
    this.status = json.status;
  }

  public get sendingStatusColor() : string {
    return Message.getColorByStatus(this.status);
  }

  public static getColorByStatus(status: SendingStatus): string {
    switch(status) {
      case SendingStatus.Unknown:
        return '#D3D3D3';
      case SendingStatus.Pending:
        return '#FFA500';
      case SendingStatus.Sent:
        return '#FF69B4';
      case SendingStatus.SendingFailure:
      case SendingStatus.CouldNotDeliver:
        return '#FF1212';
      case SendingStatus.Delivered:
        return '#FF69B4';
      case SendingStatus.Answered:
        return '#9ACD32';
      default:
        return '#D3D3D3';
    }
  }
}

export enum SendingStatus {
  Unknown = 0,
  Pending = 1,
  Sent = 2,
  SendingFailure = 3,
  Delivered = 4,
  CouldNotDeliver = 5,
  Answered = 6
}

